"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styles_1 = require("../../styles");

var Button_1 = require("../Button");

var Icon_1 = require("../Icon/Icon");

function InputWrapper(props) {
  var children = props.children,
      icon = props.icon,
      iconPosition = props.iconPosition,
      iconDisabled = props.iconDisabled,
      onIconClick = props.onIconClick,
      clearVisible = props.clearVisible,
      onClear = props.onClear;

  var _a = styles_1.useStyles(createStyles, props),
      classes = _a.classes,
      css = _a.css;

  var iconBoxClasses = css(classes.iconWrapper, iconPosition === 'left' && classes.iconLeft, iconPosition === 'right' && classes.iconRight);
  return react_1.default.createElement("div", {
    className: classes.wrapper
  }, children, clearVisible && react_1.default.createElement("span", {
    role: 'button',
    title: 'Limpar',
    tabIndex: -1,
    onClick: onClear,
    className: classes.clearButton
  }, react_1.default.createElement(Icon_1.Icon, {
    size: 1.5,
    icon: 'timesDefault'
  })), icon && react_1.default.createElement("span", {
    className: iconBoxClasses
  }, onIconClick ? react_1.default.createElement(Button_1.Button, {
    size: 'small',
    skin: 'ghost',
    tabIndex: -1,
    onClick: onIconClick,
    style: classes.icon,
    disabled: iconDisabled
  }, react_1.default.createElement(Icon_1.Icon, {
    icon: icon
  })) : react_1.default.createElement(Icon_1.Icon, {
    icon: icon,
    style: classes.icon
  })));
}

exports.InputWrapper = InputWrapper;
InputWrapper.defaultProps = {
  iconPosition: 'right',
  iconDisabled: false,
  clearVisible: false,
  onClear: function onClear() {
    return null;
  }
};

var createStyles = function createStyles(theme, _a) {
  var icon = _a.icon,
      iconPosition = _a.iconPosition,
      clearVisible = _a.clearVisible;
  var paddingRight = iconPosition === 'right' ? clearVisible && icon && '4.5rem' || clearVisible && '2rem' || icon && '3rem' : clearVisible && '2rem';
  return {
    wrapper: {
      position: 'relative',
      input: {
        paddingLeft: iconPosition === 'left' && '3rem',
        paddingRight: paddingRight
      }
    },
    clearButton: {
      position: 'absolute',
      right: icon && iconPosition === 'right' ? '2.5rem' : 1,
      background: 'transparent',
      border: 'none',
      cursor: 'pointer',
      height: '100%',
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      outline: 0,
      color: theme.pallete.text.secondary,
      padding: '1px 6px',
      '&:hover': {
        color: theme.pallete.status.danger.main
      }
    },
    iconWrapper: {
      position: 'absolute',
      backgroundColor: theme.pallete.gray.c90,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0.25rem',
      width: '2.5rem',
      top: 1,
      bottom: 1
    },
    iconLeft: {
      left: 1
    },
    iconRight: {
      right: 1
    },
    icon: {
      borderRadius: 'inherit',
      '&:focus': {
        boxShadow: 'none'
      }
    }
  };
};